import useCurrency from "../../../hooks/useCurrency"
import { Select } from "../../ui/Select"
import React from "react"




export const SelectCurrency = React.memo(({label, name, value, onChange, required, disabled, isReport}) => {
    disabled = disabled || false;
    const currency = useCurrency();
    if (isReport) {
        return (
            <p>{label}{required && "*"}: {value}</p>
        );
    }
    return (
       
            <Select 
                label={label}
                required={required}
                name={name}
                value={value}
                disabled={disabled}
                onChange={onChange}
                options={currency.map((value)=>({ value: value.CurrencyCode, display_value: value.CurrencyCode }))}
            />
        
    )
})